module.exports = __webpack_public_path__ + "static/img/baojin2.74a4e7a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baojin2.gif
// module id = 0w2a
// module chunks = 112